import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  email: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  phoneConfirmed: false,
  authenticated: false,
  userRole: "",
  customerId: "",
  sitterProfile: "",
  sitterPetPrefs: "",
  sitterServices: "",
  sitterHomeDetails: "",
  sitterLocation: "",
  regionsList: [
    {
      RegionId: 1,
      RegionName: "Central",
    },
    {
      RegionId: 2,
      RegionName: "East",
    },
    {
      RegionId: 3,
      RegionName: "North East",
    },
    {
      RegionId: 4,
      RegionName: "West",
    },
    {
      RegionId: 5,
      RegionName: "North",
    },
  ],
  countriesList: [
    {
      CountryId: 1,
      CountryName: "United Arab Emirates",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/uae_flag.png",
    },
    {
      CountryId: 9,
      CountryName: "Singapore",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/singapore_flag.png",
    },

    {
      CountryId: 3,
      CountryName: "Qatar",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/qatar_flag.png",
    },
    {
      CountryId: 4,
      CountryName: "Kuwait",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/kuwait_flag.png",
    },
    {
      CountryId: 5,
      CountryName: "Bahrain",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/bahrain_flag.png",
    },
    {
      CountryId: 6,
      CountryName: "Jordan",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/jordan_flag.png",
    },
    {
      CountryId: 7,
      CountryName: "Oman",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/oman_flag.png",
    },
    {
      CountryId: 8,
      CountryName: "Lebanon",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/lebanon_flag.png",
    },
    {
      CountryId: 2,
      CountryName: "Saudi Arabia",
      CountryFlag:
        "https://www.dupaws.com/services/images/countries/ksa_flag.png",
    },
  ],
  citiesList: "",
  selectCountry: "",
  countryData: "",
  staycationData: "",
  areasList: "",
  filteredAreasList: "",
  profilePicUrl: "",
  sitterId: "",
  sittersList: "",
  sitterPublicDetails: "",
  queryData: {
    countryId: "",
    dogwalkingdays: "",
    areaId: "",
    cityId: "",
    end: "",
    sort: 0,
    regionId: 0,
    petpref: "",
    homeType: "",
    currentPage: 0,
    serviceType: "",
    start: "",
    isOnline: "",
  },
  sitterPhotos: "",
  petsList: "",
  favoriteSitters: "",
  signalRConnection: "",
  signalRHub: "",
  subscriptionStatus: "",
  notifications: [],
};

const mutations = {
  authCheck(state, data) {
    state.authenticated = data;
  },
  selectCountry(state, data) {
    state.selectCountry = data;
  },
  subscriptionStatus(state, data) {
    state.subscriptionStatus = data;
  },
  phoneConfirmed(state, data) {
    state.phoneConfirmed = data;
  },
  calendarEvent(state, data) {
    state.calendarEvent = data;
  },
  userRole(state, data) {
    state.userRole = data;
  },
  phoneNumber(state, data) {
    state.phoneNumber = data;
  },
  sitterProfile(state, data) {
    state.sitterProfile = data;
  },
  firstName(state, data) {
    state.firstName = data;
  },
  sitterId(state, data) {
    state.sitterId = data;
  },
  customerId(state, data) {
    state.customerId = data;
  },
  lastName(state, data) {
    state.lastName = data;
  },
  email(state, data) {
    state.email = data;
  },
  sitterPetPrefs(state, data) {
    state.sitterPetPrefs = data;
  },
  sitterServices(state, data) {
    state.sitterServices = data;
  },
  sitterHomeDetails(state, data) {
    state.sitterHomeDetails = data;
  },
  sitterLocation(state, data) {
    state.sitterLocation = data;
  },
  countriesList(state, data) {
    state.countriesList = data;
  },
  countryData(state, data) {
    state.countryData = data;
  },
  staycationData(state, data) {
    state.staycationData = data;
  },
  citiesList(state, data) {
    state.citiesList = data;
  },
  regionsList(state, data) {
    state.regionsList = data;
  },
  areasList(state, data) {
    state.areasList = data;
  },
  filteredAreasList(state, data) {
    state.filteredAreasList = data;
  },
  profilePicUrl(state, data) {
    state.profilePicUrl = data;
  },
  sitterId(state, data) {
    state.sitterId = data;
  },
  sittersList(state, data) {
    state.sittersList = data;
  },
  sitterPublicDetails(state, data) {
    state.sitterPublicDetails = data;
  },
  queryData(state, data) {
    state.queryData = data;
  },
  queryDataServiceType(state, data) {
    state.queryData.serviceType = data;
  },
  sitterPhotos(state, data) {
    state.sitterPhotos = data;
  },
  deleteSitterPhoto(state, photo) {
    const index = state.sitterPhotos.findIndex(
      (t) => t.SitterPhotoId === photo.SitterPhotoId
    );
    state.sitterPhotos.splice(index, 1);
  },
  deletePet(state, pet) {
    const index = state.petsList.findIndex((t) => t.PetId === pet.PetId);
    state.petsList.splice(index, 1);
  },
  petsList(state, data) {
    state.petsList = data;
  },
  favoriteSitters(state, data) {
    state.favoriteSitters = data;
  },
  signalRConnection(state, data) {
    state.signalRConnection = data;
  },
  signalRHub(state, data) {
    state.signalRHub = data;
  },
  notifications(state, data) {
    state.notifications = data;
  },
  deleteNotification(state, notification) {
    const index = state.notifications.findIndex(
      (t) => t.UserNotificationId === notification.UserNotificationId
    );
    state.notifications.splice(index, 1);
  },
  readNotification(state, notification) {
    const index = state.notifications.findIndex(
      (t) => t.UserNotificationId === notification.UserNotificationId
    );
    if (index != null && state.notifications.length > 0) {
      state.notifications[index].IsRead = true;
    }
  },
  readNotificationTrans(state, reservationId) {
    var key = parseInt(reservationId); //iterating over notifications of reservationId X and marking them as read in vuex,
    state.notifications.forEach(function (element) {
      if (element.ServiceTransactionId == key) element.IsRead = true;
    }, this);
  },
  addNotification(state, data) {
    state.notifications.push(data);
  },
  updateNotification(state, data) {
    const index = state.notifications.findIndex(
      (t) => t.UserNotificationId === data.UserNotificationId
    );
    if (index != null && index != -1 && state.notifications.length > 0) {
      state.notifications[index].Message = data.Message;
      state.notifications[index].SentDate = data.SentDate;
      state.notifications[index].IsRead = false;
    } else {
      console.log("Couldn't update notification");
    }
  },
  clearFilters(state) {
    state.queryData = {
      areaId: null,
      cityId: null,
      end: null,
      sort: 0,
      regionId: 0,
      serviceType: null,
      start: null,
      homeType: null,
      petpref: null,
      priceRange: null,
    };
  },
};

const actions = {
  UserRole: ({ commit }, data) => commit("userRole", data),
  SubscriptionStatus: ({ commit }, data) => commit("subscriptionStatus", data),
  FirstName: ({ commit }, data) => commit("firstName", data),
  LastName: ({ commit }, data) => commit("lastName", data),
  SitterProfile: ({ commit }, data) => commit("sitterProfile", data),
  PhoneNumber: ({ commit }, data) => commit("phoneNumber", data),
  PhoneConfirmed: ({ commit }, data) => commit("phoneConfirmed", data),
  SitterPetPrefs: ({ commit }, data) => commit("sitterPetPrefs", data),
  SitterServices: ({ commit }, data) => commit("sitterServices", data),
  SitterHomeDetails: ({ commit }, data) => commit("sitterHomeDetails", data),
  SitterLocation: ({ commit }, data) => commit("sitterLocation", data),
  CountriesList: ({ commit }, data) => commit("countriesList", data),
  RegionsList: ({ commit }, data) => commit("regionsList", data),
  CitiesList: ({ commit }, data) => commit("citiesList", data),
  CountryData: ({ commit }, data) => commit("countryData", data),
  StaycationData: ({ commit }, data) => commit("staycationData", data),
  SelectCountry: ({ commit }, data) => commit("selectCountry", data),
  AreasList: ({ commit }, data) => commit("areasList", data),
  FilteredAreasList: ({ commit }, data) => commit("filteredAreasList", data),
  Email: ({ commit }, data) => commit("email", data),
  ProfilePicUrl: ({ commit }, data) => commit("profilePicUrl", data),
  SittersList: ({ commit }, data) => commit("sittersList", data),
  SitterPublicDetails: ({ commit }, data) =>
    commit("sitterPublicDetails", data),
  SitterId: ({ commit }, data) => commit("sitterId", data),
  QueryData: ({ commit }, data) => commit("queryData", data),
  SitterPhotos: ({ commit }, data) => commit("sitterPhotos", data),
  sitterId: ({ commit }, data) => commit("sitterId", data),
  CustomerId: ({ commit }, data) => commit("customerId", data),
  PetsList: ({ commit }, data) => commit("petsList", data),
  FavoriteSitters: ({ commit }, data) => commit("favoriteSitters", data),
  SignalRConnection: ({ commit }, data) => commit("signalRConnection", data),
  SignalRHub: ({ commit }, data) => commit("signalRHub", data),
  Notifications: ({ commit }, data) => commit("notifications", data),
};

const getters = {
  authenticated: (state) => state.authenticated,
  firstName: (state) => state.firstName,
  lastName: (state) => state.lastName,
  userRole: (state) => state.userRole,
  SitterProfile: (state) => state.sitterProfile,
  SitterPetPrefs: (state) => state.sitterPetPrefs,
  SubscriptionStatus: (state) => state.subscriptionStatus,
  PhoneNumber: (state) => state.phoneNumber,
  PhoneConfirmed: (state) => state.phoneConfirmed,
  SitterServices: (state) => state.sitterServices,
  SitterHomeDetails: (state) => state.sitterHomeDetails,
  SitterLocation: (state) => state.sitterLocation,
  CountriesList: (state) => state.countriesList,
  CitiesList: (state) => state.citiesList,
  RegionsList: (state) => state.regionsList,
  CountryData: (state) => state.countryData,
  StaycationData: (state) => state.staycationData,
  SelectCountry: (state) => state.selectCountry,
  AreasList: (state) => state.areasList,
  FilteredAreasList: (state) => state.filteredAreasList,
  email: (state) => state.email,
  profilePicUrl: (state) => state.profilePicUrl,
  sitterId: (state) => state.sitterId,
  SittersList: (state) => state.sittersList,
  sitterPublicDetails: (state) => state.sitterPublicDetails,
  QueryData: (state) => state.queryData,
  SitterPhotos: (state) => state.sitterPhotos,
  SitterId: (state) => state.sitterId,
  CustomerId: (state) => state.customerId,
  PetsList: (state) => state.petsList,
  FavoriteSitters: (state) => state.favoriteSitters,
  SignalRConnection: (state) => state.signalRConnection,
  SignalRHub: (state) => state.signalRHub,
  Notifications: (state) => state.notifications,
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/data/store.js